import { FilteringSourceCriteria } from "../modules/criteria/criteriaTypes";

export interface BlockPageConfig {
  is_active: boolean;
  hide_bypass_code?: boolean;
  logo?: BlockPageLogo;
  gcp_bucket_logo_location?: string;
  message?: string;
  internet_usage_policy?: string;
  permission_to_logout?: {
    source_criteria: FilteringSourceCriteria[];
  };
}

interface BlockPageLogo {
  name: string;
}

const arrayEquals = <T>(arr1: T[], arr2: T[], comparator: (o1: T, o2: T) => boolean): boolean => {
  return arr1.length === arr2.length && arr1.every((o1) => arr2.some((o2) => comparator(o1, o2)));
};

export const BlockPageConfigEquals = (c1?: BlockPageConfig, c2?: BlockPageConfig): boolean => {
  if (!c1 || !c2) {
    return c1 === c2;
  }

  let equals =
    c1.is_active === c2.is_active &&
    // treat nulls and type default values the same
    (c1.hide_bypass_code ?? false) === (c2.hide_bypass_code ?? false) &&
    (c1.logo?.name ?? "") === (c2.logo?.name ?? "") &&
    (c1.message ?? "") === (c2.message ?? "") &&
    (c1.internet_usage_policy ?? "") === (c2.internet_usage_policy ?? "");

  if (equals) {
    const arr1 = c1.permission_to_logout?.source_criteria ?? [];
    const arr2 = c2.permission_to_logout?.source_criteria ?? [];

    equals = arrayEquals(arr1, arr2, (o1, o2) => {
      if (!Array.isArray(o1.conditions) || !Array.isArray(o2.conditions)) {
        return false;
      }
      return arrayEquals(o1.conditions, o2.conditions, (a, b) => a === b);
    });
  }

  return equals;
};
